
import React from 'react';
import { useState } from "react";
import OrderForm from './OrderForm/OrderForm';
import FloatingButtons from './FloatingButtons';

import { Outlet, Link } from 'react-router-dom'; // Ensure Outlet is imported here
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaSnapchatGhost, FaInstagram, FaTiktok, FaYoutube, FaFacebookF,} from 'react-icons/fa';
import Chat from './Chat/Chat';
import Mainbanner from '../pages/Mainbanner/Mainbanner';
import Header from './Header/Header';
import Footer from './Footer/Footer';

import ScrollToTop from '../components/ScrollToTop';
import FloatingWhatsApp from "./FloatingWhatsApp/FloatingWhatsApp";
function Layout() {
  console.log("Rendering Layout");
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => setIsOpen(!isOpen);
  const closeNavbar = () => setIsOpen(false);

  return (
    <div className="d-flex flex-column min-vh-100 shadow-sm" dir="rtl">
      {/* Top Bar */}

      {/* <div style={{ backgroundColor: '#BB0315' }} className="  text-white py-2 d-none d-md-block">
  <div className="container">
    <div className="row align-items-center text-center text-md-start" dir="rtl">
      
      <div className="col-md-6 mb-3 mb-md-0 d-flex align-items-center justify-content-center justify-content-md-start">
        <FaMapMarkerAlt size={20} className="ms-2" />
        <span className="text-truncate" style={{ maxWidth: '450px' }}>
          طريق عرفات، الدار البيضاء، الرياض 14517، المملكة العربية السعودية
        </span>
      </div>

      <div className="col-md-3 mb-3 mb-md-0 d-flex justify-content-center gap-3 fs-5">
        <a className="text-white" href="https://www.snapchat.com/add/tnzeem_ksa?share_id=yoYrXo6rDCk&locale=en-EG"><FaSnapchatGhost /></a>
        <a className="text-white" href="https://www.instagram.com/tnzeem_ksa/"><FaInstagram /></a>
        <a className="text-white" href="https://www.tiktok.com/@tnzeem_ksa"><FaTiktok /></a>
        <a className="text-white" href="mailto:info@tnzeem.com"><FaEnvelope /></a>
        <a className="text-white" href="https://www.youtube.com/@tnzeem_ksa"><FaYoutube /></a>
        <a className="text-white" href="https://www.facebook.com/tnzeemksa/"><FaFacebookF /></a>
      </div>

    
      <div className="col-md-3 d-flex align-items-center justify-content-center justify-content-md-end">
        <FaPhoneAlt size={20} className="ms-2" />
        <span>920-0332-39</span>
      </div>

    </div>
  </div>
</div> */}

      {/* Navigation */}
      {/* <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img
            src="https://i.postimg.cc/902Kbr2H/cropped-Grey-01-300x119-1.webp"
            alt="Logo"
            height="50"
            className="d-inline-block align-top"
          />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          {isOpen ? (
            <span style={{ fontSize: "28px", fontWeight: "bold" }}>×</span>
          ) : (
            <span className="navbar-toggler-icon"></span>
          )}
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            {[
              { to: "/", label: "الرئيسية" },
              { to: "/magazine", label: "مجلة سياحية" },
              { to: "/contact", label: "تواصل معنا" },
              { to: "/about", label: "من نحن" },
              { to: "/destinations", label: "الوجهات السياحية" },
            ].map(({ to, label }) => (
              <li className="nav-item" key={to}>
                <Link className="nav-link" to={to} onClick={closeNavbar}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
          <Link to="/contact" className="btn btn-danger px-4 py-2 ms-lg-3" onClick={closeNavbar}>
            طلب الخدمة
          </Link>
        </div>
      </div>
    </nav> */}
    
<Header/>
      <ScrollToTop/>
      {/* Main Content */}
      <main className="flex-grow-1">
        <Outlet />
      </main>
      <Footer/>
       <FloatingWhatsApp />

{/* <Chat/> */}
      {/* Professional Footer */}
      {/* <footer className="bg-light text-dark py-5 mt-auto border-top" dir="ltr">
      <div className="container">
        
        <div className="row gy-4">
    
         <div className="col-md-4 text-center text-md-end">
    <h5 className="text-danger mb-3">تواصل معنا</h5>

    <p>
      <a href="tel:920033239" className="text-dark text-decoration-none">
        920-0332-39 <FaPhoneAlt className="ms-2" />
      </a>
    </p>

    <p>
      <a href="mailto:info@tnzeem.com" className="text-dark text-decoration-none">
        info@tnzeem.com <FaEnvelope className="ms-2" />
      </a>
    </p>

    <p className="d-flex align-items-start justify-content-end gap-3">
      <a
        href="https://www.google.com/maps/place/طريق+عرفات,+الدار+البيضاء,+الرياض"
        target="_blank"
        rel="noopener noreferrer"
        className="text-dark text-decoration-none"
      >
        طريق عرفات، الدار البيضاء، الرياض 14517، المملكة العربية السعودية
        <FaMapMarkerAlt className="fs-5 mt-2" />
      </a>
    </p>

    <div className="d-flex justify-content-center justify-content-md-end gap-3 mt-3 fs-4">
      <a href="https://www.snapchat.com/add/tnzeem_ksa?share_id=yoYrXo6rDCk&locale=en-EG" target="_blank" rel="noopener noreferrer" className="text-dark">
        <FaSnapchatGhost />
      </a>
      <a href="https://www.instagram.com/tnzeem_ksa/" target="_blank" rel="noopener noreferrer" className="text-dark">
        <FaInstagram />
      </a>
      <a href="http://tiktok.com/@tnzeem_ksa" target="_blank" rel="noopener noreferrer" className="text-dark">
        <FaTiktok />
      </a>
      <a href="https://www.youtube.com/@tnzeem_ksa" target="_blank" rel="noopener noreferrer" className="text-dark">
        <FaYoutube />
      </a>
      <a href="https://www.facebook.com/tnzeemksa/" target="_blank" rel="noopener noreferrer" className="text-dark">
        <FaFacebookF />
      </a>
    </div>
  </div>


          <div className="col-md-4 text-center">
            <h5 className="text-danger mb-3">روابط تهمك</h5>
            <ul className="list-unstyled">
              <li><Link to="/" className="text-dark text-decoration-none d-block my-1">الرئيسية</Link></li>
              <li><Link to="/magazine" className="text-dark text-decoration-none d-block my-1">مجلة سياحية</Link></li>
              <li><Link to="/contact" className="text-dark text-decoration-none d-block my-1">تواصل معنا</Link></li>
              <li><Link to="/about" className="text-dark text-decoration-none d-block my-1">من نحن</Link></li>
              <li><Link to="/terms" className="text-dark text-decoration-none d-block my-1">الشروط والأحكام</Link></li>
              <li><Link to="/privacy" className="text-dark text-decoration-none d-block my-1">سياسة الخصوصية</Link></li>
            </ul>
          </div>

      
          <div className="col-md-4 text-center text-md-end">
            <img 
              src="https://i.postimg.cc/902Kbr2H/cropped-Grey-01-300x119-1.webp" 
              alt="Tanzeem Logo" 
              height="60" 
              className="mb-3"
            />
            <p>
              متخصصون في تقديم أفضل العروض السياحية المصممة خصيصاً لتلبية احتياجاتك، مع توفير برامج سفر متنوعة وفريق التنظيم بجانبك في كل رحلة.
            </p>
            
          </div>
        </div>

      
        <div className="row mt-4" >
          <div className="col text-center ">
            <small className="text-muted">
              &copy; {new Date().getFullYear()} tnzeem.com. جميع الحقوق محفوظة.
            </small>
          </div>
        </div>
      </div>
    </footer> */}

      {/* 🟢 Add this line right before the outermost closing div */}
      {/* <FloatingButtons /> */}
    </div>
  );
}
export default Layout;